export function PaymentMethodsLoadError({
  retrying,
  onRetry,
}: {
  retrying: boolean;
  onRetry: () => void;
}) {
  return (
    <Alert severity="error" role="alert">
      <Stack spacing={1} sx={{ alignItems: "flex-start" }}>
        <span>We couldn&apos;t load your saved cards.</span>
        <Button
          variant="outlined"
          size="small"
        aria-busy={retrying || undefined}
        disabled={retrying}
        onClick={onRetry}
        >
          {retrying ? "Retrying..." : "Retry saved cards"}
        </Button>
      </Stack>
    </Alert>
  );
}
import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
